import { FC, useEffect } from 'react';
import { Modals } from '../exports/Enums';
import useUrlParams from '../../../hooks/utility/useUrlParams';
import useModalRouter from '../common/hooks/useModalRouter';

interface Props {
  children: JSX.Element;
}

const IonProvider: FC<Props> = ({ children }): JSX.Element => {
  const params = useUrlParams();
  const { open_modal } = params;
  const { openModal } = useModalRouter();

  const onDidPresent = (): void => {
    setTimeout(() => {
      window.history.replaceState({}, document.title, window.location.pathname);
    }, 1000);
  };

  const resolveModal = (): void => {
    switch (open_modal) {
      case Modals.AddCreditCard:
        return openModal({ id: Modals.AddCreditCard, onDidPresent });
      case Modals.OrderTracker:
        return openModal({
          id: Modals.OrderTracker,
          presentation: null,
          props: params,
          onDidPresent,
        });
      default:
        return;
    }
  };

  useEffect(() => {
    resolveModal();
  }, []);

  return children;
};

export default IonProvider;
